import { render } from "@testing-library/react";
import { FIELD_TYPE } from "../../type/fileType";

const { COMBO_BOX, INPUT, DATE } = FIELD_TYPE;

const columnsTableList = [
  {
    title: "STT",
    key: "stt",
    dataIndex: "stt",
    render: (text, record, index) => index + 1,
    align: "center",
  },

  {
    title: "Tên hợp đồng",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Combo/Khóa lẻ",
    dataIndex: "comboId",
    key: "comboId",
  },
  {
    title: "Tổng tiền",
    dataIndex: "totalListPrice",
    key: "totalListPrice",
  },
  {
    title: "Trạng thái",
    dataIndex: "status",
    key: "status",
    align: "center",
    render: (text, record) => {
      switch (record.status) {
        case "ACTIVE":
          return <span style={{ color: "green" }}>Hoạt động</span>;
        case "INACTIVE":
          return <span style={{ color: "red" }}>Ngừng</span>;
        case "ARCHIVED":
          return <span style={{ color: "gray" }}>Lưu trữ</span>;
        default:
          return <span>{record.status}</span>;
      }
    },
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    align: "center",
  },
];

const dataUploadTemplate = [
  {
    type: COMBO_BOX,
    label: "Khóa lẻ",
    name: "courseId",
    css: { xs: 12, sm: 12, md: 24, xl: 24 },
    rules: [{ required: true, message: "Chưa chọn combo" }],
  },
];

const dataFindContract = [
  {
    type: INPUT,
    label: "Từ khóa tên hợp đồng",
    name: "keyword",
  },
];

export { columnsTableList, dataUploadTemplate, dataFindContract };
